import * as tslib_1 from "tslib";
import HLabel from "../../../../../form/src/common/components/label.vue";
import { labelText } from "../../../../../form/src/schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let SequenceNo = class SequenceNo extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], SequenceNo.prototype, "control", void 0);
SequenceNo = tslib_1.__decorate([
    Component({
        name: 'SequenceNo',
        components: {
            HLabel: HLabel
        }
    })
], SequenceNo);
export default SequenceNo;
